import { ACCESS_LEVELS } from '@/lib/consts.ts'

export default {
  name: 'stats-and-reports',
  path: 'stats-and-reports/:path(.*)?',
  meta: {
    accessLevel: ACCESS_LEVELS.MANAGER,
    hintKey: 'hintFeatureStats',
    useSmartlook: true,
  },
  component: () => import('@/views/business/stats-and-reports.vue'),
}
